import React, { FC, memo } from "react";

import { ISvG } from "~/types/SvGTypes";

const Icon: FC<ISvG> = ({ fill = "#EE8D00" }) => {
  return (
    <svg
      width="10"
      height="4"
      viewBox="0 0 10 4"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M5 0L9.33013 3.75H0.669873L5 0Z" fill={fill} />
    </svg>
  );
};

export default memo(Icon);
